import React, { FC } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import DateStepInput from '../../../../components/inputs/DateStepInput'
import { getMaxDate, getMinDate } from '../../../../utils/dateUtils'
import { MoveOutFormFields } from '../MoveOutWizard'

interface StartOfContractDateStepProps {
	form: UseFormReturn<MoveOutFormFields>
}

const StartOfContractDateStep: FC<StartOfContractDateStepProps> = ({ form }) => {
	const minDate = getMinDate()
	const maxDate = getMaxDate()
	const { t } = useTranslation('modals_moveOutContact')

	return (
		<DateStepInput<MoveOutFormFields>
			form={form}
			fieldName='contractStartAt'
			minDate={minDate}
			maxDate={maxDate}
			label={t('startOfContractDateStep.startOfContractDate')}
			description={t('startOfContractDateStep.description')}
		/>
	)
}

export default StartOfContractDateStep
